module.exports = __webpack_public_path__ + "static/showreel_2023_clip-18c7283e4ff0f982967eabe1bb43f952.mp4";